export const clientCompaniesTableColumns = [
  {
    prop: 'is_active',
    title: 'common.filters.active',
    width: '7%',
    sortingEnabled: true,
  },
  {
    prop: 'fullname',
    title: 'common.fields.full_name',
    width: '40.77%',
    sortingEnabled: true,
  },
  {
    prop: 'short_name',
    title: 'common.fields.short_name',
    width: '20.06%',
    sortingEnabled: true,
  },
  {
    prop: 'contacts',
    title: 'common.fields.contacts',
    width: '16.24%',
    sortingEnabled: true,
  },
  {
    prop: 'address_city',
    title: 'adm.companies.company_dialog.city',
    width: '5.62%',
    sortingEnabled: true,
  },
  {
    prop: 'actions',
    title: 'common.fields.actions',
    width: '10.31%',
    sortingEnabled: false,
  },
];
